import React from 'react';
import cn from 'classnames';

import { playSound } from '@/common/lib/soundEffect';
import { toggleSettingMenu } from '@/redux/reducers/modalsReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

import { Container } from '../Container/container';

import cross from '/img/icons/settings/cross.svg';

const BurgerSettings: React.FC = () => {
  const isActive = useAppSelector((state) => state.modals.settingsIsOpen);
  const dispatch = useAppDispatch();

  const onClick = (): void => {
    playSound('buttons/menu');
    dispatch(toggleSettingMenu());
  };

  return (
    <Container
      variant="blur-20"
      className={cn(
        'flex flex-col items-center justify-center gap-[0.125rem] !w-8 !h-8 p-2 cursor-pointer',
      )}
      onClick={onClick}
    >
      {isActive ? (
        <img src={cross} alt="cross" className="w-6 h-6" />
      ) : (
        Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="w-full h-[0.125rem] bg-[#FFFFFFCC] rounded-full"
          ></div>
        ))
      )}
    </Container>
  );
};

export default BurgerSettings;
